<template>
    <section id="loading" class="page">
        <header class="main transparent">
            <h1><img class="logo" src="img/logo_white.svg" width="40" alt="" />Rozgrzewka głosu</h1>
        </header>

        <div class="content with-padding">
            <div class="animation">
                <img src="img/spin.svg" width="90" alt="" />
                <p>Proszę czekać</p>
            </div>
        </div>

        <footer class="main">
            <p class="partner">Partner aplikacji: <img src="img/logo_isla.png" width="100" alt="" /></p>
        </footer>
    </section>
</template>

<script>
    import router from '../router'
    import resize from '../mixins/resize'

    export default {
        name: 'Loading',
        mixins: [resize],
        created: function() {
            setTimeout(function() {
                router.push('start');
            }, 2000);
        }
    }
</script>
